import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Kliiniku nimi", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Logo", -1)
const _hoisted_7 = { class: "w-1/2 inline-flex items-center space-x-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Kiirgustegevusloa omaja", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "max-w-3xl flex items-start my-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-4 w-1/2" }, "Kiigustegevusloa numbrid:", -1)
const _hoisted_14 = { class: "flex-col w-1/2" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "h-4 w-4 mt-2 text-gray-500 hover:text-red-600",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "mt-1 inline-flex w-full justify-around" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-1 h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Lisa uus ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Kiirgustegevuse asukoht", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Aruande esitaja nimi", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_29 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Aruande esitaja e-mail", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_32 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Aruande esitaja telefon", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_35 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Raamatupidaja e-mail", -1)
const _hoisted_37 = { class: "max-w-3xl flex justify-end my-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AddImageForm = _resolveComponent("AddImageForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputField, {
        class: "w-1/2",
        value: _ctx.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
      }, null, 8, ["value"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.logo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "h-28 w-64 bg-contain bg-center bg-no-repeat rounded-md",
              style: _normalizeStyle({ 'background-image': `url(${_ctx.logo})` })
            }, null, 4))
          : _createCommentVNode("", true),
        _createVNode(_component_AddImageForm, {
          class: "w-36",
          onOnLogo: _ctx.onLogo,
          haveLogo: !!_ctx.logo
        }, null, 8, ["onOnLogo", "haveLogo"])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_InputField, {
        class: "w-1/2",
        value: _ctx.radiationPracticeLicenseHolder,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radiationPracticeLicenseHolder) = $event))
      }, null, 8, ["value"])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenseNos, (_, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex items-center w-full",
            key: `licence_no_${i}`
          }, [
            _createVNode(_component_InputField, {
              class: _normalizeClass(["mt-2", i === 0 ? 'w-full' : 'w-11/12']),
              placeholder: "Kiirgustegevusloa number",
              value: _ctx.licenseNos[i],
              "onUpdate:value": ($event: any) => ((_ctx.licenseNos[i]) = $event)
            }, null, 8, ["class", "value", "onUpdate:value"]),
            (i !== 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "ml-4 focus:outline-none",
                  onClick: ($event: any) => (_ctx.removeLicenceNo(i))
                }, _hoisted_17, 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.showAddNewLicenceNoButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewLicenceNo && _ctx.addNewLicenceNo(...args))),
                type: "button",
                class: "uppercase tracking-wider hover:bg-orange-100 transition duration-300 ease-in-out flex items-center px-3 py-2 border border-transparent text-xs leading-4 font-medium rounded-md text-gray-500 hover:text-orange-700 focus:outline-none"
              }, _hoisted_21))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createVNode(_component_InputField, {
        value: _ctx.licenceLocation,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.licenceLocation) = $event)),
        class: "w-1/2"
      }, null, 8, ["value"])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode(_component_InputField, {
        value: _ctx.rapporteurName,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rapporteurName) = $event)),
        class: "w-1/2"
      }, null, 8, ["value"])
    ]),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createVNode(_component_InputField, {
        value: _ctx.rapporteurEmail,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rapporteurEmail) = $event)),
        class: "w-1/2"
      }, null, 8, ["value"])
    ]),
    _hoisted_31,
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createVNode(_component_InputField, {
        value: _ctx.rapporteurPhone,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rapporteurPhone) = $event)),
        class: "w-1/2"
      }, null, 8, ["value"])
    ]),
    _hoisted_34,
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createVNode(_component_InputField, {
        value: _ctx.accountantEmail,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountantEmail) = $event)),
        class: "w-1/2"
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args))),
        class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-500 ease-in-out"
      }, " Salvesta ")
    ])
  ]))
}